import { getTooltipAttributes } from "@common/contexts/Tooltip";
import Icon from "@common/controls/Icon/component";
import Preloader from "@common/controls/Preloader/component";
import ResponsiveContainer from "@common/controls/ResponsiveContainer/component";
import { IconType } from "@common/declarations";
import { useI18n } from "@common/hooks/i18n";
import classNames from "classnames";
import { isUndefined } from "lodash";
import React from "react";

export type CardListProps = {
  aspectRatio?: string | number;
  children: any;
  className?: string;
  columns?: number;
  disabledTooltip?: string;
  isBusy?: boolean;
  /**
   * undefined - unavailable
   * null - disabled
   */
  onAdd?: (() => void) | null;
  addLabel?: string;
  addStyle?: React.CSSProperties;
  maxHeight?: string | number;
};
const CardList = (props: CardListProps) => {
  const i18n = useI18n();

  const style: React.CSSProperties = props.columns
    ? ({
        "--grid-template": Array.from({ length: props.columns }, (_) => "1fr").join(" ")
      } as any)
    : {};
  return (
    <div
      className={classNames("card_list", props.className, {
        grid: !!props.columns
      })}
      style={style}
    >
      {React.Children.map(props.children, (x, i) => (
        <ResponsiveContainer
          style={{ maxHeight: props.maxHeight }}
          aspectRatio={props.aspectRatio}
          key={i.toString()}
          containerClassName="card_container"
        >
          {x}
        </ResponsiveContainer>
      ))}

      {!isUndefined(props.onAdd) && (
        <ResponsiveContainer
          style={{ maxHeight: props.maxHeight }}
          aspectRatio={props.aspectRatio}
          containerClassName="card_container add_card"
          onClick={props.isBusy || props.disabledTooltip || !props.onAdd ? undefined : props.onAdd}
        >
          <div
            className={classNames("add_button", { disabled: !!props.disabledTooltip || !props.onAdd })}
            style={props.addStyle}
            {...getTooltipAttributes(props.disabledTooltip)}
          >
            {props.isBusy ? (
              <Preloader type="bars" />
            ) : (
              <>
                <Icon icon={IconType.Add} />
                {props.addLabel ?? i18n.add}
              </>
            )}
          </div>
        </ResponsiveContainer>
      )}
    </div>
  );
};

export default CardList;
